/* eslint-disable max-len */
import React from 'react';

const CheckboxCheckedIcon = () => (
  <svg
    viewBox="0 0 24 24"
    height="24"
    width="24"
    focusable="false"
    aria-hidden="true"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M18 3a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h12zm-1.53 4.97L10 14.44l-2.47-2.47a.75.75 0 0 0-1.06 1.06l3 3c.3.3.77.3 1.06 0l7-7a.75.75 0 0 0-1.06-1.06z"></path>
  </svg>
);

export default CheckboxCheckedIcon;
